export const POPUP_STATUS_SUCCESS = 'SUCCESS';
export const POPUP_STATUS_ERROR = 'ERROR';
